<template>
  <v-tooltip
    v-bind="$attrs"
    :value="isOpen"
    :open-on-hover="false"
    :max-width="width"
    z-index="100"
    content-class="is-clickable-tooltip"
    color="primary"
  >
    <template #activator="{ attrs }">
      <v-icon
        v-click-outside="outsideClick"
        middle
        :style="`float:${iconFloat};`"
        class="mr-1"
        color="grey"
        v-bind="attrs"
        @click.stop="isOpen = !isOpen"
      >
        mdi-information-outline
      </v-icon>
    </template>
    <slot name="tooltip-body" />
  </v-tooltip>
</template>

<script>
export default {
  name: 'qz-tooltip',
  props: {
    width: {
      type: Number,
      default: 320,
    },
    iconFloat: {
      type: String,
      default: undefined,
    },
  },
  data () {
    return {
      isOpen: false,
    };
  },
  methods: {
    outsideClick () {
      if (this.isOpen) this.isOpen = false;
    },
  },
};
</script>
